import React from 'react';
import ForgotPassword from './ForgotPassword';

const ForgotUsername = () => <ForgotPassword initialMode="username" />;

export default ForgotUsername;
